(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maie-campaign-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(root){root.querySelectorAll('.maie-campaign').forEach(function(section){
  var video=section.querySelector('video'),button=section.querySelector('[data-campaign-toggle]');
  if(!video||!button||section.dataset.videoReady)return;
  section.dataset.videoReady='true';video.muted=true;video.playsInline=true;video.controls=false;
  var manualPause=false,inView=false,reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  function stop(){video.pause();}
  function play(){video.play().catch(function(){section.classList.remove('is-playing');});}
  function sync(){var playing=!video.paused;section.classList.toggle('is-playing',playing);button.textContent=button.getAttribute(playing?'data-pause':'data-play');button.setAttribute('aria-label',button.textContent);}
  video.addEventListener('play',sync);video.addEventListener('pause',sync);
  video.addEventListener('error',function(){stop();section.classList.remove('is-playing');});
  button.addEventListener('click',function(){if(video.paused){manualPause=false;play();}else{manualPause=true;stop();}});
  function auto(){if(inView&&!document.hidden&&!manualPause&&!reduced.matches&&!(navigator.connection&&navigator.connection.saveData))play();else stop();}
  if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){inView=entries[0].isIntersecting;auto();},{threshold:.5});observer.observe(section);section.addEventListener('shopify:section:unload',function(){observer.disconnect();stop();});}
  document.addEventListener('visibilitychange',auto);if(reduced.addEventListener)reduced.addEventListener('change',auto);
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maie-campaign-offer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var button=event.target.closest('[data-maie-copy]');
  if(!button)return;
  var status=button.closest('.maie-offer').querySelector('[data-maie-copy-status]');
  var code=button.getAttribute('data-maie-copy');
  if(!navigator.clipboard){status.textContent=code;return;}
  navigator.clipboard.writeText(code).then(function(){status.textContent=button.getAttribute('data-copied');button.classList.add('is-copied');clearTimeout(button._maieT);button._maieT=setTimeout(function(){button.classList.remove('is-copied');},2600);}).catch(function(){status.textContent=code;});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maie-editorial-photos"] && !Shopify.designMode) return;
  try {
    
function claimEditorialPhotos(root){
  const merch=window.MAIE&&window.MAIE.merch;
  if(!merch||!merch.claim)return;
  root.querySelectorAll('[data-editorial-handle]').forEach(function(card){merch.claim(card.dataset.editorialHandle);});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){claimEditorialPhotos(document);});
else claimEditorialPhotos(document);
document.addEventListener('shopify:section:load',function(event){claimEditorialPhotos(event.target);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viral-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.mf'); if(!root) return;
  root.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.mf-col__btn'); if(!b) return;
    var col = b.closest('.mf-col'), open = !col.classList.contains('is-open');
    col.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
